import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackIcon from "../../../../../Images/backIcon.png";

const ExperienceConfigurationUI = ({
  accountName,
  roleName,
  roleId,
  accountId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("role-configuration");
  const [inputType, setInputType] = useState(null);

  // Get all incoming router state safely
  const incomingState = location?.state || {};

  // Safely extract structural references
  const safeRoleId = roleId ?? incomingState?.roleId;
  const safeAccountId = accountId ?? incomingState?.accountId;

  const safeAccountName =
    accountName ?? incomingState?.accountName;

  const safeRoleName =
    roleName ??
    incomingState?.name ??
    incomingState?.roleName;

  // Extract operational settings safely
  const dartsFormNeeded = incomingState?.dartsFormNeeded;
  const pocName = incomingState?.pocName;
  const pocEmail = incomingState?.pocEmail;
  const pocNumber = incomingState?.pocNumber;
  const numberLogin = incomingState?.numberLogin;
  const emailLogin = incomingState?.emailLogin;
  const mandatoryTimeDistribution =
    incomingState?.mandatoryTimeDistribution;
  const targetEditDays = incomingState?.targetEditDays;
  const inputEditDays = incomingState?.inputEditDays;
  const dartsNeeded = incomingState?.dartsNeeded;
  const clanNeeded = incomingState?.clanNeeded;
  const syncNeeded = incomingState?.syncNeeded;
  const geoTracking = incomingState?.geoTracking;
  const signInSignOutRequired =
    incomingState?.signInSignOutRequired;
  const locationRequired = incomingState?.locationRequired;
  const jobroleAccessUserIds =
    incomingState?.jobroleAccessUserIds;
  const ldmsNeeded = incomingState?.ldmsNeeded;
  const mirrorNeeded = incomingState?.mirrorNeeded;

  /*
    Complete state object.

    First spread incomingState so that any additional state
    coming from the previous page is also preserved.

    Then override the important values with the latest safe values.
  */
  const fullState = {
    ...incomingState,

    roleId: safeRoleId,
    accountId: safeAccountId,
    accountName: safeAccountName,
    name: safeRoleName,
    roleName: safeRoleName,

    dartsNeeded:
      inputType !== null
        ? true
        : dartsNeeded ?? false,

    clanNeeded: clanNeeded ?? false,
    syncNeeded: syncNeeded ?? false,

    dartsFormNeeded:
      inputType !== null
        ? inputType === "Forms"
        : dartsFormNeeded ?? false,

    pocName: pocName ?? "",
    pocEmail: pocEmail ?? "",
    pocNumber: pocNumber ?? "",

    numberLogin: numberLogin ?? false,
    emailLogin: emailLogin ?? false,

    mandatoryTimeDistribution:
      mandatoryTimeDistribution ?? false,

    targetEditDays: targetEditDays ?? 0,
    inputEditDays: inputEditDays ?? 0,

    geoTracking: geoTracking ?? false,

    signInSignOutRequired:
      signInSignOutRequired ?? false,

    locationRequired: locationRequired ?? false,

    jobroleAccessUserIds:
      jobroleAccessUserIds ?? [],

    ldmsNeeded: ldmsNeeded ?? false,
    mirrorNeeded: mirrorNeeded ?? false,
  };

  useEffect(() => {
    console.log(
      "[ExperienceConfiguration] accountName:",
      safeAccountName
    );

    console.log(
      "[ExperienceConfiguration] roleName:",
      safeRoleName
    );

    console.log(
      "[ExperienceConfiguration] fullState:",
      fullState
    );
  }, [safeAccountName, safeRoleName]);

  // Go back to Dashboard with complete state
  const handleBackToViewRole = () => {
    navigate("/dashboard", {
      state: fullState,
    });
  };

  // If another page needs to return to Experience Configuration,
  // it can use this same complete state.
  const handleBackToExperience = () => {
    navigate("/experience-configuration", {
      state: fullState,
    });
  };

  return (
    <div className="bg-gray-100 h-full flex flex-col ml-12">
      <div className="mb-6">

        {/* Back Button */}
        <button
          onClick={handleBackToViewRole}
          className="
            flex
            items-center
            gap-1
            bg-[#C21A17]
            text-white
            px-5
            py-2
            rounded-lg
            text-sm
            font-semibold
            shadow-md
            cursor-pointer
            mb-4
            ml-[-4.5px]
            -mt-2
          "
        >
          <img
            src={BackIcon}
            alt="Back"
            className="
              w-[15px]
              object-contain
              transition-transform
              duration-300
              hover:scale-105
            "
          />

          Back
        </button>

        {/* Breadcrumb */}
<div className="relative top-[-4px] flex items-center text-sm">
          {/* Account Name */}
          {safeAccountName && (
            <>
              <span
                onClick={() =>
                  navigate("/admin")
                }
                className="
                  cursor-pointer
                  text-[14px]
                  text-[#939393]
                "
              >
                {safeAccountName}
              </span>

              <span className="mx-2 text-[14px] text-[#939393]">
                ›
              </span>
            </>
          )}

          {/* Role Name */}
          {safeRoleName && (
            <>
              <span
                onClick={() =>
                  navigate("/dashboard", {
                    state: fullState,
                  })
                }
                className="
                  cursor-pointer
                  text-[14px]
                  text-[#939393]
                "
              >
                {safeRoleName}
              </span>

              <span className="mx-2 text-[14px] text-[#939393]">
                ›
              </span>
            </>
          )}

          {/* Current Page */}
          <span className="font-semibold text-[14px] text-[#1B1B1B]">
            Experience Configuration
          </span>
        </div>
      </div>

      {/* Main Content */}
      <div className="
        flex
        flex-1
        justify-center
        text-center
        items-start
        pt-16
        pb-4
      ">
        <div>

          <h1 className="
            text-[44px]
            font-bold
            tracking-[0.5px]
            text-[#AD0101]
            mb-4
            mr-2
            leading-[0px]
          ">
            Experience Configuration
          </h1>

          <p
            className="
    text-[#393939]
    text-[18px]
    font-[500]
    leading-[28px]
    text-center
    max-w-[560px]
    mx-auto
    mt-10
    mb-12
  "
          >
            Configure and manage your platform experience with product
            <br />
            and master-level settings.
          </p>

          <div className="flex gap-7 ml-18 mr-[-0.5px]">

            {/* Masters Configuration */}
            <button
              onClick={() =>
                navigate("/masterConfiguration", {
                  state: fullState,
                })
              }
              className="
                w-[270px]
                border-2
                border-[#1F2020]
                text-[#AD0101]
                px-8
                py-3
                font-semibold
                bg-white
                shadow-[-3px_3px_0px_#b91c1c]
                transition-all
                duration-200
                hover:-translate-x-[2px]
                hover:-translate-y-[2px]
                hover:shadow-[-5px_5px_0px_#b91c1c]
              "
            >
              Masters Configuration
            </button>

            {/* Products Configuration */}
            <button
              onClick={() =>
                navigate("/productsConfiguration", {
                  state: fullState,
                })
              }
              className="
                w-[270px]
                border-2
                border-[#1F2020]
                text-[#AD0101]
                px-8
                py-3
                font-semibold
                bg-white
                shadow-[-3px_3px_0px_#b91c1c]
                transition-all
                duration-200
                hover:-translate-x-[2px]
                hover:-translate-y-[2px]
                hover:shadow-[-5px_5px_0px_#b91c1c]
              "
            >
              Products Configuration
            </button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceConfigurationUI;